<template>
  <div class="b44-page">
    <div class="b44-header">
      <div>
        <router-link class="b44-link" :to="voltarPara">
          <i class="bi bi-chevron-left"></i> Voltar
        </router-link>
        <h1 class="b44-title" style="margin-top:0.75rem">Manual — Portfólio e Dashboard</h1>
        <p class="b44-sub">Explicação das notas, cards e regras para quem acompanha os projetos</p>
      </div>
      <a
        class="b44-link"
        :href="docUrl"
        target="_blank"
        download="ROBOFLEX_PORTFOLIO_AUDITOR.md"
      >
        <i class="bi bi-download"></i> Baixar Markdown
      </a>
    </div>

    <div v-if="loading" class="b44-loading"><div class="b44-spinner"></div></div>
    <div v-else-if="erro" class="b44-card p-6" style="margin-top:1.5rem;color:#b91c1c">
      {{ erro }}
    </div>
    <article v-else class="b44-card p-6 b44-doc" style="margin-top:1.5rem" v-html="html"></article>
  </div>
</template>

<script>
import "@/assets/css/portfolio-auditor.css";
import { markdownToHtml } from "@/utils/markdownLite";
import { getPermissao } from "@/services/permissao-service";

export default {
  name: "DocumentacaoPortfolioAuditor",
  data() {
    return {
      loading: true,
      html: "",
      erro: "",
    };
  },
  computed: {
    docUrl() {
      const base = process.env.BASE_URL || "/";
      return `${base}docs/ROBOFLEX_PORTFOLIO_AUDITOR.md`;
    },
    voltarPara() {
      const from = this.$route.query.from;
      if (from === "dashboard") return { name: "dashboardProjetosAuditor" };
      if (from === "detalhe" && this.$route.query.id) {
        return { name: "portfolioProjetoDetalheAuditor", params: { id: this.$route.query.id } };
      }
      return { name: "portfolioProjetosAuditor" };
    },
  },
  async mounted() {
    try {
      await getPermissao(116);
      const res = await fetch(this.docUrl);
      if (!res.ok) throw new Error(`Não foi possível carregar o documento (${res.status}).`);
      const md = await res.text();
      this.html = markdownToHtml(md);
    } catch (e) {
      this.erro = e?.message || "Erro ao carregar a documentação.";
    } finally {
      this.loading = false;
    }
  },
};
</script>
